import { useNavigate } from 'react-router-dom';

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const navigate = useNavigate();

  return (
    <nav
      aria-label="Breadcrumb"
      className="bg-stone-50 border-b border-stone-100"
    >
      <div className="max-w-screen-xl mx-auto px-4 lg:px-8 py-2.5">
        <ol className="flex items-center gap-1.5 flex-wrap">
          <li>
            <button
              onClick={() => navigate('/')}
              className="flex items-center gap-1 text-xs text-stone-400 hover:text-amber-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-home-4-line text-[11px]" />
              Home
            </button>
          </li>
          {items.map((item, index) => (
            <li key={index} className="flex items-center gap-1.5">
              <i className="ri-arrow-right-s-line text-stone-300 text-sm" />
              {item.href && index < items.length - 1 ? (
                <button
                  onClick={() => item.href && navigate(item.href)}
                  className="text-xs text-stone-400 hover:text-amber-700 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {item.label}
                </button>
              ) : (
                <span className="text-xs text-stone-700 font-medium whitespace-nowrap">
                  {item.label}
                </span>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
}
